import * as _ from "lodash";
import {ForgotPassword as Validator} from '../../utils/validators';

interface Action {
    payload: any,
    type: string,
    field: string,
    apiError?: string | boolean,
    value?: any,
    validate: boolean
}

interface Form {
    valid: boolean,
    changed: boolean
    data: {
        [key: string]: {
            required: boolean,
            added: boolean,
            value: any,
            error: any,
            dirty: false,
            errTypes?: any
        },
    }
}

const initialState: Form = {
    valid: false,
    data: {
        email: {
            required: true,
            added: false,
            value: null,
            error: null,
            dirty: false
        },
        newPassword: {
            required: true,
            added: false,
            value: null,
            error: null,
            dirty: false,
            errTypes: {
                u: false,
                l: false,
                n: false,
                min: false
            }
        },
        confirmPassword: {
            required: true,
            added: false,
            value: null,
            error: null,
            dirty: false,
            errTypes: {
                u: false,
                l: false,
                n: false,
                min: false
            }
        },
    },
    changed: false,
};

const baseState = _.cloneDeep(initialState);

const ForgotPassword = (state = initialState, action: Action) => {
    switch (action.type) {
        case 'FORGOT_PASSWORD_FORM_CHANGE':
            return Validator({...state.data}, action);
        case 'RESET_FORGOT_PASSWORD':
            return _.cloneDeep(baseState);
        case 'CHECK_RESET_PASS_TOKEN':
            Object.assign(state, {tokenStatus: action.payload});
            return {...state};
        default:
            return state;
    }
};

export default ForgotPassword;
